<template>
  <page :title="i18n.title">
    <div class="confirm-warp">
      <div class="vcard flex-s pay-amount">
        <div class="pay-amount-title">{{ i18n.pay_label }}</div>
        <div style="color: #00ab46" class="flex-c">
          <span class="doller">{{ currency }}</span>
          <span class="pay-price">{{ priceFormat(price) }}</span>
        </div>
      </div>
      <div class="pay-h1"></div>
      <div class="confirm-payment">
        <template
          v-if="payType === 'YJ' || payType === 'FK'"
        >
          <div
            v-for="(item, i) in cardList"
            :key="i"
            class="confirm-payment-item"
            @click="onPayMode(item, true)"
          >
            <div class="confirm-payment-item-info">
              <img :src="require('../../assets/imgs/icon_creditcard.png')" />
              <div class="content">
                <div class="title">{{ item.pCardnumber }}</div>
              </div>
            </div>
            <div class="confirm-payment-item-checked 1">
              <img
                v-if="
                  payMode.pId === item.pId &&
                  item.currencyName === payMode.currencyName
                "
                src="../../assets/imgs/checkbox_selected.png"
              />
              <img v-else src="../../assets/imgs/checkbox.png" />
            </div>
          </div>
        </template>
        <template v-for="item in payModeList">
          <div
            v-if="
              item.phone === 'all' ||
              item.phone === system ||
              item.phone === browser ||
              (item.phone === 'phone' && system !== '')
            "
            :key="item.pId"
            class="confirm-payment-item"
            @click="onPayMode(item)"
          >
            <div class="confirm-payment-item-info">
              <img
                :src="
                  item.pPaymentType === 'GOOGLE_PAY' ||
                  item.pPaymentType === 'STRIPE_GOOGLE'
                    ? require('../../assets/imgs/icon_googlepay.png')
                    : item.pPaymentType === 'APPLE_PAY' ||
                      item.pPaymentType === 'STRIPE_APPLE'
                    ? require('../../assets/imgs/icon_applepay.png')
                    : require('../../assets/imgs/icon_creditcard.png')
                "
              />
              <div>
                <div class="title">
                  {{
                    $t("confirm." + item.label).includes("confirm.")
                      ? item.label
                      : $t("confirm." + item.label)
                  }}
                </div>
                <!-- <div v-if="item.pPaymentType === 'STRIPE_CARD'" class="sub_title">{{ i18n.auth_label }}</div> -->
                <div
                  v-if="item.pPaymentType === 'STRIPE_CARD'"
                  class="sub_title"
                >
                  {{ system == "ios" ? "Apple Pay" : "Google Pay" }}
                </div>
              </div>
            </div>
            <div class="confirm-payment-item-checked 2">
              <img
                v-if="
                  payMode === item.pPaymentType &&
                  item.currencySymbol === currencySymbol
                "
                src="../../assets/imgs/checkbox_selected.png"
              />
              <img v-else src="../../assets/imgs/checkbox.png" />
            </div>
          </div>
        </template>
      </div>
      <div class="confirm-btns">
        <div class="btn" @click="onPay" :disabled="disabled">
          {{ i18n.confirmpay }}
        </div>
      </div>
      <popup-warp v-model="isCreditcard">
        <div>
          <div class="creditcard-input">
            <div id="credit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripeSetup">
            {{ i18n.confirmpay }}
          </div>
        </div>
      </popup-warp>
      <popup-warp v-model="isDebitcard">
        <div>
          <div class="creditcard-input">
            <div id="debit-card-element"></div>
          </div>
          <div class="btn creditcard-btn" @click="onStripePay">
            {{ i18n.confirmpay }}
          </div>
        </div>
      </popup-warp>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { SelectArea } from "../../components/select"
import { getToken } from "../../utils/stripe_pay.js"
import {
  STRIPE_PREPAY_SPTOKEN,
  STRIPE_PAYORDER_SPTOKEN,
  PAYPAL_PRE_PAY,
  PAYPAL_RECHARGE,
  STRIPE_PAY_OF_CONFIRM,
  STRIPE_RECHARGE_OF_CONFIRM,
  STRIPE_PAY_CONFIRM,
  STRIPE_PREAUTH_OF_CONFIRM,
  STRIPE_PREAUTH_AUTO_CONFIRM,
  PAYMODE,
  STRIPE_PAYORDER,
  STRIPE_RECHARGE_WALLET,
  STRIPE_CARD_PAY,
  STRIPE_SAVE_CARD,
  STRIPE_SAVE_CARD_CONFIRM,
  SAVED_CARD_TO_RENT,
  INVOICE_BUYORDER
} from "../../apis/payment"
import { USER_CARD } from "../../apis/user.js"
import stripeMixin from "../../mixins/stripe"
import { PopupWarp } from "../../components/popup"

export default {
  mixins: [stripeMixin],
  components: {
    PopupWarp,
    SelectArea
  },
  computed: {
    ...mapState([
      "system",
      "browser",
      "cabinet",
      "user",
      "qrcode",
      "wallet",
      "agentOpenId"
    ]),
    i18n() {
      return this.$t("confirm")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    currency() {
      if (this.cabinet) {
        return this.cabinet.currencyName
      } else {
        return this.currencySymbol || this.user.pcurrencyName
      }
    }
  },
  watch: {
    payMode(val, oldVal) {
      console.log("payMode", val, typeof val)
      if (
        val === "APPLE_PAY" ||
        val === "STRIPE_APPLE" ||
        val === "STRIPE_GOOGLE" ||
        val === "GOOGLE_PAY"
      ) {
        if (!this.stripePayRequest) {
          this.disabled = true
          this.$loading(true)
          this.getStripeToken()
        } else {
          this.disabled = false
        }
      } else {
        this.disabled = false
      }
    },
    stripePayRequest(val, oldVal) {
      this.disabled = !val
    }
  },
  data() {
    return {
      areaCode: "86",
      price: 0,
      payType: "YJ",
      formId: "",
      cabinetID: "",
      yaJinType: null,
      pdailiId: "",
      payMode: "STRIPE_CARD",
      pId: "", // 代理或平台支付配置id
      currencySymbol: "$",
      country: "US", // 国家
      currencyname: "usd", // 货币类型
      publicKey: "", // 支付通道的公钥
      disabled: false,
      stripePayRequest: null,
      isCreditcard: false,
      cardStyle: {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      },
      creditcard: null,
      clientSecret: null,
      debitOrder: null,
      isDebitcard: false,
      isIdael: false,
      mpesaPhoneShow: false,
      isAreaView: false,
      isDopago: false,
      debitcard: null,
      payModeList: [],
      cardList: [],
      orderId: "",
      mifiOrderId: "",
      phone: "",
      emailAddress: "",
      confirmType: "preAuth",
      round: 5,
      flutterwaveDialog: false
    }
  },
  methods: {
    priceFormat(val) {
      if (val) {
        return val % 1 === 0 ? val : val.toFixed(2)
      }
      return val
    },
    filterPay() {
      if (this.browser === "wechat") {
        return ["STRIPE_WECHAT", "WeChat_MP"]
      } else {
        return this.payModeList.map((item) => item.pPaymentType)
      }
    },
    goWallet() {
      let sn = this.mifisn || (this.mifiOrder && this.mifiOrder.productSendSn)
      if (this.payType === "mifi") {
        if (this.mificode.indexOf("http") !== -1) {
          this.$router.push(
            `/wallet?mificode=${encodeURIComponent(this.mificode)}&type=mifi`
          )
        } else {
          this.$router.push(`/wallet?sn=${sn}`)
        }
      } else {
        this.$router.push(`/wallet?qrcode=${this.mificode}&type=cdb`)
      }
    },
    onSelct(val) {
      this.areaCode = val
    },
    goRouter(path) {
      this.$router.push(path)
    },
    // 支付方式选中
    onPayMode(v, bool = false) {
      console.log("支付方式===", v)
      if (bool) {
        this.payMode = v
      } else {
        this.pId = v.pId
        this.payMode = v.pPaymentType
        this.currencySymbol = v.currencySymbol
        this.currencyname = v.pCurrencyType
        this.publicKey = v.publicKey
        this.country = v.configDetails.accountCountry
        if (this.payMode.includes("STRIPE_CARD")) {
          this.loadStripeScript(this.publicKey)
        }
      }
    },
    getStripeToken() {
      getToken(this.price, "MY", this.currencyname.toLowerCase(), this.onStripe)
        .then((data) => {
          console.log("stripe getToken", data)
          this.stripePayRequest = data
          this.$loading(false)
        })
        .catch((error) => {
          this.stripePayRequest = null
          console.log("stripe getTokenerr", error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          })
        })
    },
    // apple和Google支付时调用
    onStripe(token, ev) {
      let url = ""
      let datas = {}
      let headers = {}
      if (this.cabinet && this.payType === "YJ") {
        url = STRIPE_PREPAY_SPTOKEN
        datas = {
          qrcode: this.cabinet.qrcode,
          stripeToken: token, // stripe官方支付的一次性token
          paymentId: this.pId // 代理或平台支付配置id
        }
      } else if (this.price > 0 && this.payType === "FK") {
        url = STRIPE_PAYORDER_SPTOKEN
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          stripeToken: token,
          paymentId: this.pId
        }
      } else {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push("/")
        })
      }
      this.$post(
        url,
        datas,
        (resp) => {
          if (ev && ev.complete) {
            ev.complete("success")
          }
          this.$loading(false)
          console.log(resp)
          if (this.payType === "CZ") {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace("/mine")
            })
          } else if (this.payType === "overbuy") {
            this.$router.replace(
              `/invoiceOrderDtl?orderId=${
                resp.data.buyOrderNo || resp.data.orderId
              }`
            )
          } else {
            this.$toast(this.i18nMsg.success_payment)
            if (this.payType === "FK") {
              this.$router.replace(
                `/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=stripe&payType=FK`
              )
              return
            }
            this.$router.replace(
              `/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=stripe`
            )
          }
        },
        (error) => {
          if (ev && ev.complete) {
            ev.complete("fail")
          }
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        },
        headers
      )
    },
    onPay() {
      console.log("onPay ~ payMode:", this.payMode)
      if (this.payMode === "PAYPAL") {
        this.onPaypal()
      } else if (
        this.payMode === "APPLE_PAY" ||
        this.payMode === "STRIPE_APPLE" ||
        this.payMode === "STRIPE_GOOGLE" ||
        this.payMode === "GOOGLE_PAY"
      ) {
        this.stripePayRequest.show()
      } else if (this.payMode === "STRIPE_CARD") {
        this.onCreditcard()
      } else {
        this.$loading(true)
        setTimeout(() => {
          this.$loading(false)
          this.$router.replace("/result?loading=false")
        }, 3000)
      }
    },
    onPaypal() {
      this.$loading(true)
      let url = ""
      let datas = {
        amount: this.price
      }
      let headers = {}
      if (this.payType === "CZ") {
        url = PAYPAL_RECHARGE
      } else if (this.payType === "overbuy") {
        url = INVOICE_BUYORDER
        datas = {
          outTradeNo: this.$route.query.orderId,
          paymentId: this.pId
        }
        headers = {
          headers: {
            "content-type": "application/json;charset=UTF-8"
          }
        }
      } else if (this.cabinet) {
        url = `${PAYPAL_PRE_PAY}/${this.cabinet.qrcode}`
      }
      this.$post(
        url,
        datas,
        (resp) => {
          this.$loading(false)
          if (resp.data && resp.data.checkOutUrl) {
            if (this.payType === "overbuy") {
              this.$store.commit('paypalType', "overbuy")
            }
            this.$store.commit('paypalTradeNo', resp.data.paymentId)
            this.$store.commit('paymentId', this.pId)
            // this.$loading(true)
            window.location.href = resp.data.checkOutUrl
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        },
        headers
      )
    },
    stripeCardPay() {
      this.$loading(true)
      this.$post(
        `${STRIPE_CARD_PAY}/${this.mificode}`,
        {
          cardId: this.payMode.pId
        },
        (resp) => {
          this.$loading(false)
          console.log("数据===", resp)
          if (resp.data && resp.data.clientSecret) {
            // 该卡需要3ds认证
            this.clientSecret = resp.data
            this.onStripeSetup(false)
          } else if (resp.data && resp.data.outTradeNo) {
            if (this.payType === "mifi") {
              this.$router.replace(
                `/borrowSuccess?tradeNo=${
                  resp.data.outTradeNo
                }&payMode=stripe&loading=${
                  this.mifiOrder && !this.mifiOrder.xugou
                }`
              )
            } else {
              this.$router.replace(
                `/borrowSuccess?tradeNo=${resp.data.outTradeNo}&payMode=stripe&loading=true`
              )
            }
          } else {
            this.$toast(resp.msg)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            // content: this.i18n.msg_fail_order,
            content: error,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.stripeCardPay()
          })
          console.log(error)
        }
      )
    },
    onCreditcard() {
      const { paymentWay } = this.$route.query
      let paymentId = this.pId
      let headers = {}
      if (this.paymentConfig && this.paymentConfig.pId) {
        paymentId = this.paymentConfig.pId
      }

      if (paymentWay === "PAYMENT_CARD") {
        return this.saveCard()
      }
      let url = ""
      let datas = {}
      if (this.cabinet && this.payType === "YJ") {
        url = `${STRIPE_PREAUTH_OF_CONFIRM}/${this.cabinet.cabinetID}`
        datas = {
          paymentId: paymentId,
          amount: this.price
        }
        if (this.paymentConfig) {
          return this.cardToRent(this.paymentConfig)
        }
      } else if (this.price > 0 && this.payType === "FK") {
        url = STRIPE_PAYORDER
        datas = {
          outTradeNo: this.orderId,
          couponNo: null,
          paymentId: paymentId
        }
        if (this.paymentConfig) {
          datas.cardId = this.pId
        }
      } else if (this.payType === "overbuy") {
        url = INVOICE_BUYORDER
        datas = {
          outTradeNo: this.$route.query.orderId,
          paymentId: paymentId
        }
        headers = {
          headers: {
            "content-type": "application/json;charset=UTF-8"
          }
        }
      } else {
        url = STRIPE_RECHARGE_WALLET
        datas = {
          amount: this.price,
          paymentId: paymentId
        }
      }
      this.$loading(true)
      this.$post(
        url,
        datas,
        (resp) => {
          this.$loading(false)
          console.log(url, resp)
          if (resp.data) {
            if (datas.cardId && this.payType === "FK") {
              this.checkOrder(datas.outTradeNo, this.payType)
              return
            }
            if (window.stripe) {
              this.clientSecret = resp.data
              const layout = {
                layout: "tabs"
              }
              const options = {
                clientSecret: resp.data.clientSecret,
                appearance: {
                  theme: "stripe"
                }
              }
              this.creditcard = window.stripe.elements(options)
              const paymentElement = this.creditcard.create("payment", layout)
              this.isCreditcard = true
              paymentElement.mount("#credit-card-element")
            } else {
              console.log(" stripe:", window.stripe)
              this.$toast("loading...")
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard()
          })
          console.log(error)
        },
        headers
      )
    },
    onStripeSetup() {
      const vm = this
      vm.$loading(true)
      const { paymentWay } = this.$route.query
      // 失败事件回调
      const failCall = (result) => {
        console.log(result)
        vm.$loading(false)
        if (result.error) {
          vm.$toast(result.error.message)
        }
      }
      if (paymentWay === "PAYMENT_CARD") {
        let url = `${window.location.origin}#/confirm?qrcode=${this.cabinet.qrcode}&paymentId=${this.pId}&pmid=${this.creditOrder.paymentId}`
        window.stripe
          .confirmSetup({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: url
            }
          })
          .then((result) => failCall(result))
      } else {
        window.stripe
          .confirmPayment({
            elements: vm.creditcard,
            confirmParams: {
              // Make sure to change this to your payment completion page
              return_url: `${window.location.href}&paymentId=${this.pId}`
            }
          })
          .then((result) => failCall(result))
      }
    },
    confirmSetup(id, success) {
      const { paymentWay } = this.$route.query
      this.$loading(true)
      let url = `${STRIPE_PREAUTH_AUTO_CONFIRM}?tradeNo=${id}`
      let datas = {}
      this.$get(
        url,
        datas,
        (resp) => {
          this.$loading(false)
          this.isCreditcard = false
          if (paymentWay === "PAYMENT_SAVED_PROPAY") {
            this.saveCard()
          }
          let jumpUrl = `/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=stripe`
          if (this.payType === "overbuy") {
            jumpUrl = `/invoiceOrderDtl?orderId=${
              resp.data.buyOrderNo || resp.data.orderId
            }`
          } else if (this.payType !== "YJ") {
            jumpUrl = `/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=stripe&payType=${this.payType}`
          }
          this.$router.replace(jumpUrl)
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    // stripe充值余额租借
    stripeRechargeWallet() {
      this.$loading(true)
      this.$post(
        STRIPE_RECHARGE_WALLET,
        {
          amount: this.price,
          paymentId: this.pId
        },
        (resp) => {
          this.$loading(false)
          this.clientSecret = resp.data
          this.confirmType = "czOrder"
          if (resp.data) {
            if (window.stripeElements) {
              this.loadStripeScript(this.publicKey)
              this.creditcard = window.stripe.elements({
                appearance: { theme: "stripe" },
                clientSecret: resp.data.clientSecret
              })
              const linkAuthenticationElement =
                this.creditcard.create("linkAuthentication")
              linkAuthenticationElement.mount("#link-authentication-element")
              linkAuthenticationElement.on("change", (event) => {
                this.emailAddress = event.value.email
              })
              const paymentElement = this.creditcard.create("payment", {
                layout: "tabs"
              })
              paymentElement.mount("#payment-element")
              this.$nextTick(() => {
                this.isIdael = true
              })
            } else {
              this.loadStripeScript(this.publicKey)
              this.$toast("loading...")
            }
          }
          // this.confirmSetup(resp.data.tradeNo, '', 'czOrder')
          // this.$router.replace(`/borrowSuccess?tradeNo=${resp.data.orderId}&payMode=stripe`)
          console.log(resp)
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onStripePay() {
      const vm = this
      vm.$loading(true)
      window.stripe
        .handleCardPayment(vm.debitOrder.clientSecret, vm.debitcard)
        .then((result) => {
          console.log("result", result)
          if (result.error) {
            vm.$loading(false)
            vm.$toast(result.error.message)
          } else {
            window.stripe
              .retrievePaymentIntent(vm.debitOrder.clientSecret)
              .then((result) => {
                console.log("init result", result)
                vm.$loading(false)
                if (result.paymentIntent) {
                  vm.confirmPay(result.paymentIntent.id)
                }
              })
          }
        })
    },
    confirmPay(id) {
      this.$loading(true)
      this.$post(
        STRIPE_PAY_CONFIRM,
        {
          paymentId: id,
          outTradeNo: this.debitOrder.outTradeNo
        },
        (resp) => {
          this.$loading(false)
          this.isCreditcard = false
          if (this.payType === "CZ") {
            this.$router.go(-2)
          } else if (this.payType === "overbuy") {
            this.$router.replace(`/invoiceOrderDtl?orderId=${resp.data}`)
          } else if (this.cabinet) {
            this.$router.replace(
              `/borrowSuccess?tradeNo=${resp.data}&payMode=stripe`
            )
          }
          console.log(resp)
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onDebitcard() {
      this.$loading(true)
      let url = ""
      if (this.payType === "CZ") {
        url = STRIPE_RECHARGE_OF_CONFIRM
      } else if (this.cabinet) {
        url = `${STRIPE_PAY_OF_CONFIRM}/${this.cabinet.qrcode}`
      }
      this.$post(
        url,
        {
          amount: this.price
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            if (window.stripeElements) {
              this.debitOrder = resp.data
              this.loadStripeScript(this.publicKey)
              this.debitcard = window.stripeElements.create("card", {
                style: this.cardStyle
              })
              this.debitcard.mount("#debit-card-element")
              this.$nextTick(() => {
                this.isDebitcard = true
              })
            } else {
              this.$toast("loading...")
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onDebitcard(this.publicKey)
          })
          console.log(error)
        }
      )
    },
    getPayMode() {
      let agentId = ""
      let url = `${PAYMODE}${`?id=${
        this.qrcode || this.$route.query.cabinetID
      }`}`
      if (this.payType === "CZ") {
        agentId = this.wallet ? this.wallet.pDailiId : this.agentOpenId
        url = `${PAYMODE}?agentId=${agentId}`
      } else if (this.payType === "overbuy") {
        url = `${PAYMODE}?pOrderId=${this.$route.query.orderId}`
      }
      this.$loading(true)
      this.$get(
        url,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            let list = resp.data
            list.map((v, i, arr) => {
              if (v.pPaymentType === "STRIPE_CARD") {
                v.label = "Credit Card"
                v.phone = "all"
              } else if (v.pPaymentType === 'PAYPAL') {
                v.label = 'Paypal'
                v.phone = 'all'
              }
            })
            this.payModeList = list
            if (list.length > 0) {
              let useCrad = list.filter((v) => {
                return v.label !== "Unknow"
              })
              useCrad = useCrad.length ? useCrad : [{ configDetails: {} }]
              this.payMode = useCrad[0].pPaymentType
              this.currencySymbol = useCrad[0].currencySymbol // 货币符号
              this.currencyname = useCrad[0].configDetails.currency // 货币类型
              this.publicKey = useCrad[0].publicKey
              this.pId = useCrad[0].pId
              this.country = useCrad[0].configDetails.accountCountry
              console.log(this.publicKey, this.payMode)
              if (this.payMode.includes("STRIPE")) {
                this.loadStripeScript(this.publicKey)
              }
            } else {
              this.disabled = true
            }
            console.log("list======", list)
          }
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        },
        {
          headers: {
            agentOpenId:
              this.mifiOrder &&
              this.mifiOrder.xugou &&
              process.env.VUE_APP_Domain === "https://saas.dtoolsz.com"
                ? "BJCD0000000000000000000000000001"
                : ""
          }
        }
      )
    },
    getUserCardList() {
      let url = ""
      if (this.payType === "CZ") {
        url = `${USER_CARD}?userEnd=web${
          this.walletItem ? `&agentId=${this.wallet.pDailiId}` : ``
        }`
      } else if (
        (this.mificode && this.mificode.indexOf("http") === -1) ||
        this.payType === "YJ"
      ) {
        url = `${USER_CARD}?userEnd=web&qrcode=${this.mificode}`
      } else {
        url = `${USER_CARD}?userEnd=web&agentId=${this.agentOpenId}`
      }
      this.$loading(true)
      this.$get(
        url,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          this.cardList = resp.data
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.getUserCardList()
          })
          console.log(error)
        },
        {
          headers: {
            agentOpenId: this.agentOpenId
          }
        }
      )
    },
    saveCard() {
      const { paymentWay, paymentId } = this.$route.query
      console.log("this.payMode", this.payMode)
      if (!this.user) {
        this.$toast(this.i18nMsg.unlogin)
        return
      }
      if (!this.payMode || !this.pId) {
        this.$toast(this.i18nMsg.nopaymode)
        return
      }
      let url = `${STRIPE_SAVE_CARD}?paymentId=${paymentId || this.pId}`
      this.$loading(true)
      this.$post(
        url,
        {},
        (resp) => {
          this.$loading(false)
          this.creditOrder = resp.data
          if (paymentWay === "PAYMENT_CARD") {
            this.onLoadElement()
          }
          // this.onCreditcard(this.publicKey)

          console.log("saveCard====", resp)
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.saveCard()
          })
          console.warn(error)
        }
      )
    },
    onLoadElement() {
      const options = {
        clientSecret: this.creditOrder.clientSecret,
        appearance: {
          theme: "stripe"
        }
      }
      if (window.stripe) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripe.elements(options)
        const paymentElement = this.creditcard.create("payment")
        this.isCreditcard = true
        // this.payListShow = false
        paymentElement.mount("#credit-card-element")
      } else {
        this.$toast("loading...")
        this.loadStripeScript()
        setTimeout(() => {
          this.onLoadElement()
        }, 500)
      }
    },
    checkOrder(tradeNo, payType, query) {
      if (payType === "CZ") {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.success_payment,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.replace("/mine")
        })
      } else {
        if (payType === "FK") {
          this.$router.replace(
            `/result?tradeNo=${tradeNo}&payMode=stripe&payType=FK`
          )
          return
        }
        this.$router.replace(`/result?tradeNo=${tradeNo}&payMode=stripe`)
      }
    },
    onConfirmSaveCard(pid, id) {
      this.$loading(true)
      this.$post(
        STRIPE_SAVE_CARD_CONFIRM,
        {
          paymentId: pid,
          paymentMethod: id
        },
        (resp) => {
          this.$loading(false)
          console.log("saveCardConfirm====", resp)
          //   this.getCardList()
          this.saveToRent()
        },
        (error) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nMsg.msg_fail_title,
            content: error,
            confirmText: this.i18nMsg.retry,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.onConfirmSaveCard(pid, id)
          })
          console.log(error)
        }
      )
    },
    saveToRent() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.out_trade_no) {
            this.checkOrder(resp.data.out_trade_no, this.payType)
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    }
  },
  created() {
    let price = this.$route.query.price
    let { paymentId, pmid } = this.$route.query
    let formId = this.$route.query.formId
    this.price = price ? Number(price) : 0
    this.orderId = this.$route.query.outTradeNo
    this.formId = formId
    this.payType = this.$route.query.payType
    this.cabinetID = this.$route.query.cabinetID
    this.yaJinType = this.$route.query.yaJinType
    this.getPayMode()
    if (
      this.payType === "YJ" ||
      this.payType === "FK"
    ) {
      this.getUserCardList()
    }
    const payId = new URLSearchParams(window.location.search).get(
      "payment_intent"
    )
    console.log(`query-payId:${payId}-paymentId:${paymentId}-pmid:${pmid}`)

    if (paymentId && pmid) {
      this.onConfirmSaveCard(paymentId, pmid)
    } else if (payId) {
      this.confirmSetup(payId)
    }
    console.log(this)
  }
}
</script>

<style lang="less">
#form-checkout {
  display: flex;
  flex-direction: column;
  max-width: 600px;
  .container {
    height: 50px;
    display: inline-block;
    border: 1px solid rgb(118, 118, 118);
    border-radius: 2px;
    padding: 1px 2px;
    margin-bottom: 10px;
  }
  & > select {
    height: 60px;
    margin-bottom: 10px;
  }
  & > input {
    height: 50px;
    margin-bottom: 10px;
  }
  & > button {
    background: #65b74e;
    color: #ffffff;
    border: none;
    outline: none;
    padding: 20px 0;
    margin-top: 20px;
  }
  .progress-bar {
    width: 100%;
  }
}

.noClick {
  opacity: 0.5;
  pointer-events: none; /* 禁止鼠标点击 */
}
.confirm-warp {
  overflow-y: scroll;
}
.confirm-info {
  background: #ffffff;
  text-align: center;
  padding: 40px;
}
.confirm-title {
  font-size: 36px;
}
.confirm-price {
  font-size: 80px;
  color: #fc0d1b;
}
.confirm-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
  & span {
    text-align: left;
    font-size: 28px;
    color: #999999;
  }
}
.confirm-payment {
  background: #ffffff;
  padding: 30px;
  &-label {
    padding: 10px 20px;
    font-size: 28px;
    color: #999999;
  }
  &-item {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    border-bottom: 1px solid #dddddd;
    & img {
      width: 40px;
      height: 40px;
    }
    &-info {
      display: flex;
      align-items: center;
      flex: 1;
      & .content {
        padding-left: 10px;
      }
      & .sub_title {
        font-size: 28px;
        color: #fec348;
      }
    }
    &-operate {
      display: flex;
      justify-content: flex-end;
      &-text {
        padding: 4px 12px;
        font-size: 28px;
        color: #fc0d1b;
      }
    }
  }
}
.confirm-remark {
  padding: 0 32px;
}
.confirm-remark .title {
  margin-top: 40px;
  font-size: 32px;
}
.confirm-remark .desc {
  font-size: 28px;
  color: rgba(102, 102, 102, 1);
  font-weight: 400;
  word-break: normal !important;
  white-space: normal !important;
}
.confirm-btns {
  padding: 60px 40px 20px;
}
.confirm-btns .btn {
  margin-top: 20px;
}
/* #ifdef MP-WEIXIN */
.confirm-btns button.btn {
  background-color: #65b74e;
}
/* #endif */
.confirm-checkbox {
  padding: 30px;
  & label {
    display: flex;
    align-items: center;
  }
  & span {
    color: #52ac7a;
  }
}
.btn-paypal {
  background: #fec348 !important;
}
.btn-paypal img {
  width: 277px;
  height: 60px;
  margin: 18px 0;
}
.btn-applepay {
  background: #ffffff !important;
  color: #050608;
}
.btn-applepay img {
  width: 143px;
  height: 60px;
  margin: 18px 0;
}
.btn-googlepay {
  color: #5f6368;
  background: #ffffff !important;
}
.btn-googlepay img {
  width: 145px;
  height: 60px;
  margin: 18px 0;
}
.creditcard-input {
  margin: 48px 48px 100px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}
.creditcard-btn {
  margin: 48px;
}
.confirm-row {
  margin: 36px 45px 140px;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 4px solid rgb(211, 211, 211);
  border-radius: 20px;
  .area {
    width: 100px;
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  input {
    font-size: 32px;
    width: 300px;
    flex: 1;
    height: 80px;
    padding: 0 20px;
    margin: 0;
    border: none;
    outline: none;
    background-color: rgba(0, 0, 0, 0);
  }
  .area-down {
    // margin-left: 10px;
    width: 0;
    height: 0;
    border-width: 10px 10px 0;
    border-style: solid;
    border-color: black transparent transparent;
  }
  .login-code {
    width: 180px;
    height: 60px;
    background-image: linear-gradient(
      to right,
      rgba(194, 194, 194, 1),
      rgba(252, 252, 252, 1)
    );
    img {
      width: 180px;
      height: 60px;
    }
  }
}
.pay-amount {
  padding: 43px 20px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  margin-top: 40px;

  .pay-amount-title {
    font-size: 30px;
    font-family: Work Sans-Medium, Work Sans;
    font-weight: 500;
    color: #444444;
  }

  .doller {
    font-size: 30px;
    font-family: Work Sans-Regular, Work Sans;
  }

  .pay-price {
    font-size: 54px;
    font-family: Work Sans-Bold, Work Sans;
    font-weight: bold;
    padding: 0 10px;
  }
}

.pay-h1 {
  font-size: 32px;
  font-family: Work Sans-Bold, Work Sans;
  font-weight: bold;
  color: #333333;
  padding: 40px 40px 20px 40px;
}
</style>
